import Header from '../components/Header';
import { Link } from 'react-router-dom';
import './Home.css';
import { HEADACHE_NOTE_APP_STORE_URL, HEADACHE_NOTE_GOOGLE_PLAY_URL } from '../constants/storeLinks';
import headacheNoteIcon from '../assets/headache-note-icon.png';
import screenshot1 from '../assets/screenshots/headache-note-screenshot-1.png';
import screenshot2 from '../assets/screenshots/headache-note-screenshot-2.png';
import screenshot3 from '../assets/screenshots/headache-note-screenshot-3.png';
import screenshot4 from '../assets/screenshots/headache-note-screenshot-4.png';

function HeadacheNote() {
  return (
    <div className="Home" id="headache-note">
      <Header />
      <main>
        <section className="About">
          <h1 className="PageTitle">
            <img
              className="PageTitleIcon"
              src={headacheNoteIcon}
              alt=""
              aria-hidden="true"
            />
            頭痛ノート
          </h1>
          <p>
            頭痛ノートは、日々の頭痛の強さ・発生時刻・きっかけ・対処法などを簡単に記録し、
            後から集計・傾向把握ができるシンプルな記録アプリです。トリガーや有効な対策を見つける助けになります。
          </p>
          <ul>
            <li>素早く記録</li>
            <li>データで傾向を可視化</li>
            <li>役立つコラム配信</li>
          </ul>
          <div className="Screenshots">
            <img src={screenshot1} alt="スクリーンショット1" />
            <img src={screenshot2} alt="スクリーンショット2" />
            <img src={screenshot3} alt="スクリーンショット3" />
            <img src={screenshot4} alt="スクリーンショット4" />
          </div>
          <div className="StoreLinks">
            <a
              className="StoreLink"
              href={HEADACHE_NOTE_APP_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="App Store"
            >
              App Store
            </a>
            <a
              className="StoreLink"
              href={HEADACHE_NOTE_GOOGLE_PLAY_URL}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Google Play"
            >
              Google Play
            </a>
          </div>
        </section>
      </main>
      <footer className="SiteFooter">
        <nav className="LegalLinks">
          <Link to="/headache-note/terms">利用規約</Link>
          <span aria-hidden="true" style={{ margin: '0 0.5rem' }}>|</span>
          <Link to="/headache-note/privacy">プライバシーポリシー</Link>
        </nav>
        <small>© {new Date().getFullYear()} YStudioX</small>
      </footer>
    </div>
  );
}

export default HeadacheNote;
